import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=56981398&"
import script from "./CustomDialog.vue?vue&type=script&lang=js&"
export * from "./CustomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports